import { render } from "./PolicyPage.vue?vue&type=template&id=33f7b046&ts=true"
import script from "./PolicyPage.vue?vue&type=script&lang=ts"
export * from "./PolicyPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Profile/PolicyPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33f7b046"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33f7b046', __exports__)) {
    api.reload('33f7b046', __exports__)
  }
  
  module.hot.accept("./PolicyPage.vue?vue&type=template&id=33f7b046&ts=true", () => {
    api.rerender('33f7b046', render)
  })

}


export default __exports__